export default function PageHeading({ title }) {
  return (
    <div className="td-container py-6">
      <h1 className="text-lg font-medium flex items-center space-x-4">{title}</h1>
    </div>
  )
}
